import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectModalOnboarding } from '../store/onboardingSlice';
import { selectBaseUrl, selectStageCheckList } from '../store/trainingKbSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './TrainingKbModal.css';

const TrainingKbModal = () => {
  // Redux state
  const modalOnboarding = useAppSelector(selectModalOnboarding);
  const baseUrl = useAppSelector(selectBaseUrl);
  const stageCheckList = useAppSelector(selectStageCheckList);


  // Get training KB data from the onboarding object
  const trainingKb = modalOnboarding?.stages?.trainingKb?.status === 'completed';

  const formatBoolean = (value) => {
    return value ? 'Completed' : 'No';
  };

  return (
    <div className="space-y-4">
      
      { modalOnboarding && (
        <div>
          <p className={`training-kb-status${trainingKb ? ' training-kb-status-active' : ' training-kb-status-inactive'}`}>{formatBoolean(trainingKb)}</p>
          <GenericUpdateForm onboarding={modalOnboarding} stage="trainingKb" baseUrl={baseUrl} />
          
          {/* Checklist Component */}
          <Checklist 
            stage="trainingKb" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistoryTrainingKb = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="training-kb-history-row">
      <td className="training-kb-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="training-kb-history-cell">
        Not set
      </td>
      <td className="training-kb-history-cell">
        {onboarding.stages?.trainingKb?.status ? '✅' : '❌'}
      </td>
      <td className="training-kb-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { TrainingKbModal };
